export const OVERLAY_CLICKED = 'OVERLAY_CLICKED';
export const ANNOTATION_CLICKED = 'ANNOTATION_CLICKED';
export const CLEAR_ALL_PENDING_COMMENTS = 'CLEAR_ALL_PENDING_COMMENTS';
export const UPDATE_SUBMITTED_COMMENTS = 'UPDATE_SUBMITTED_COMMENTS';
export const UPDATE_COLLABORATION_GROUPS = 'UPDATE_COLLABORATION_GROUPS';
export const UPDATE_COLLABORATION_LOADING_STATE = 'UPDATE_COLLABORATION_LOADING_STATE';
export const UPDATE_COLLABORATION_SUBMITTING_REVIEW_STATE = 'UPDATE_COLLABORATION_SUBMITTING_REVIEW_STATE';
export const COLLABORATION_ACTIVE_STATUS = 'active';
export const TOGGLE_ANNOTATIONS_VISIBILITY_CLICK = 'TOGGLE_ANNOTATIONS_VISIBILITY_CLICK';
export const ADD_TEMP_GROUP = 'ADD_TEMP_GROUP';
export const GET_COLLABORATION_DIDNT_WORK = 'GET_COLLABORATION_DIDNT_WORK';
